import React from 'react';
import {
  LocalOffer as ServiceIcon,
  Settings as OptionsIcon,
  Person as StaffIcon,
  Schedule as TimeIcon,
  CheckCircle as ConfirmIcon,
  PersonAdd as CustomerIcon,
} from '@mui/icons-material';
import './MobileStepper.css';

const steps = [
  {
    label: 'Service',
    description: 'Choose your service',
    icon: ServiceIcon,
    color: '#FF6B6B',
    colorDark: '#E55A5A',
    rgb: '255, 107, 107'
  },
  {
    label: 'Additional Options',
    description: 'Customize your booking',
    icon: OptionsIcon,
    color: '#9B59B6',
    colorDark: '#8B4AA6',
    rgb: '155, 89, 182'
  },
  {
    label: 'Date',
    description: 'Choose your booking date',
    icon: TimeIcon,
    color: '#45B7D1',
    colorDark: '#3AA6C1',
    rgb: '69, 183, 209'
  },
  {
    label: 'Staff',
    description: 'Select your preferred staff',
    icon: StaffIcon,
    color: '#4ECDC4',
    colorDark: '#3DBCB4',
    rgb: '78, 205, 196'
  },
  {
    label: 'Time',
    description: 'Pick a convenient time',
    icon: TimeIcon,
    color: '#45B7D1',
    colorDark: '#3AA6C1',
    rgb: '69, 183, 209'
  },
  {
    label: 'Customer',
    description: 'Enter your details',
    icon: CustomerIcon,
    color: '#FFB347',
    colorDark: '#E6A23F',
    rgb: '255, 179, 71'
  },
  {
    label: 'Confirm',
    description: 'Review and book',
    icon: ConfirmIcon,
    color: '#96CEB4',
    colorDark: '#86BEA4',
    rgb: '150, 206, 180'
  },
];

const MobileStepper = ({ activeStep, theme = 'light' }) => {
  const progressPercentage = ((activeStep + 1) / steps.length) * 100;

  return (
    <div className={`mobile-stepper ${theme}`}>
      {/* Progress Indicator */}
      <div className="stepper-progress">
        <div className="progress-text">
          Step {activeStep + 1} of {steps.length}
        </div>
        <div className="progress-bar">
          <div
            className="progress-fill"
            style={{
              width: `${progressPercentage}%`,
              '--step-color': steps[activeStep]?.color || '#FF6B6B'
            }}
          />
        </div>
      </div>

      {/* Current Step Only */}
      {(() => {
        const currentStep = steps[activeStep];
        if (!currentStep) return null;

        const { label, description, icon: Icon, color, colorDark, rgb } = currentStep;

        return (
          <div
            key={label}
            className="step-item active"
            style={{
              '--step-color': color,
              '--step-color-dark': colorDark,
              '--rgb-color': rgb,
              '--progress-color': rgb
            }}
            role="button"
            tabIndex={0}
            aria-label={`${label} - Current step`}
          >
            <div className="step-icon">
              <Icon />
            </div>
            <div className="step-content">
              <div className="step-title">{label}</div>
              <div className="step-description">{description}</div>
            </div>
            <div className="step-status">
              Now
            </div>
          </div>
        );
      })()}
    </div>
  );
};

export default MobileStepper;